import { Alert } from "@instructure/ui-alerts";
import { t } from "i18next";

const NotAuthorized = () => {
  return <Alert variant="error">{t("errorPage.noAccess")}</Alert>;
};

export default NotAuthorized;
